import { useEffect, useState } from 'react';

/** Tailwind's md breakpoint: below it modals render as bottom sheets. */
const MOBILE_VIEWPORT_QUERY = '(max-width: 767px)';

// matchMedia is absent during SSR and in jsdom test runs, so both the
// initialiser and the effect check for it before use.
const canQueryViewport = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export const useIsMobileViewport = () => {
  // Initialised from matchMedia so a bottom sheet does not flash centred
  // before the effect runs on a phone.
  const [isMobileViewport, setIsMobileViewport] = useState(
    () => canQueryViewport() && window.matchMedia(MOBILE_VIEWPORT_QUERY).matches
  );

  useEffect(() => {
    if (!canQueryViewport()) return undefined;

    const mediaQueryList = window.matchMedia(MOBILE_VIEWPORT_QUERY);
    const updateViewport = () => setIsMobileViewport(mediaQueryList.matches);
    updateViewport();
    mediaQueryList.addEventListener('change', updateViewport);
    return () => mediaQueryList.removeEventListener('change', updateViewport);
  }, []);

  return isMobileViewport;
};
